export const SRO_ITEMS = {
  "01(I)/2022": ["1", "2", "3", "4"],

  "1450(I)/2021": ["1", "2", "3", "4"],

  "1579(I)/2021": ["1", "2", "3", "4"],

  "1604(I)/2021": ["1", "2", "3", "4"],

  "297(I)/2023-Table-I": [
    "1",
    "2",
    "3",
    "4",
    "6",
    "7",
    "9",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
  ],

  "321(I)/2022": ["1", "2", "3", "4"],

  "321(I)/2008": ["1", "2", "3", "4"],

  "3rd Schedule goods": ["51"],

  "581(1)/2024": ["Region-I", "Region-II"],

  "587(I)/2017": ["1"],

  "6th Schedule Table-I": [
    "6",
    "8",
    "10A",
    "10B",
    "10C",
    "10D",
    "10E",
    "10F",
    "10G",
    "10H",
    "14",
    "15",
    "15(a)",
    "15(b)",
    "15(c)",
    "17",
    "18",
    "19",
    "20",
    "24",
    "25",
    "30",
    "33",
    "34",
    "35",
    "36",
    "37",
    "40",
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
    "47",
    "48",
    "49",
    "50",
    "51",
    "52",
    "53",
    "54",
    "55",
    "56",
    "56(i)",
    "57",

    "100",
    "100A",
    "100A(i)",
    "100A(ii)",
    "100(i)",
    "100(ii)",
    "100(iii)",
    "100B",
    "100B(i)",
    "100B(ii)",
    "100B(iii)",
    "100B(iv)",
    "100C",
    "101",
    "103",
    "104(a)",
    "104(b)",
    "104(c)",
    "104(d)",
    "104(e)",
    "104(f)",
    "104(g)",
    "104(h)",
    "106",
    "107",
    "108",
    "108(a)",
    "108(b)",
    "108(c)",
    "108(d)",
    "108(e)",
    "108(f)",
    "108(g)",
    "108(h)",
  ],

  "6th Schedule Table-II": ["20", "22"],

  "88(I)/2022": ["1", "2", "3", "4"],

  "Eighth Schedule Table-I": [
    "19",
    "22",
    "23",
    "26",
    "34",
    "43",
    "45",
    "50",
    "51",
    "53",
    "56",
    "57",
    "67",
    "70",
    "73(a)",
    "77",
    "80",
    "81",
    "82",
    "83",
    "84(i)",
    "84(ii)",
    "84(iii)",
    "84(iv)",
    "84(v)",
    "84(vi)",
    "85",
    "87",
    "88",
    "89",
    "90",
  ],

  "Fifth Schedule": [
    "1(i)",
    "1(ii)",
    "1(iii)",
    "1(iv)",
    "1(v)",
    "6",
    "6(a)",
    "6(A)(ii)",
    "6(A)(iv)",
    "6(A)(v)",
    "6(A)(vi)",
    "6(A)(vii)",
    "6(A)(viii)",
    "6(A)(ix)",
    "6(A)(x)",
    "7",
    "8",
    "8A",
    "12(xvii)",
    "12(xx)",
    "12(xxi)",
    "12(xxii)",
    "12(xxiii)",
    "12(xxiv)",
    "12(xxv)",
    "154",
    "155",
    "2",
    "20",
    "21",
  ],
  ICTO: ["3(1A)"],
  "ICTO Table-I": [
    "1(i)",
    "1(ii)",
    "1(b)",
    "10",
    "11(a)",
    "11(b)",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "39",
    "40",
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
    "47",
    "48",
    "49",
    "50",
    "51",
    "52",
    "53",
    "54",
    "55",
    "56",
    "57",
    "58",
    "59",
    "6",
  ],
};
